import React from "react";
import nextId from "react-id-generator";
import {
  createCollege,
  createCourse,
  createSpecialization,
  createUniversity,
} from "../../../../../APIs/PostAPIS";
import CustomCheckBox from "../../../../Common/CustomCheckbox/CustomCheckBox";
import CustomDropdown from "../../../../Common/CustomDropdown/CustomDropdown";
import { MainContext } from "../../../../Dashboard/DashboardContext/Context";
import "./qualification-form.style.scss";
export default function QualificationForm({
  data,
  handleChanges,
  handleDelete,
  num,
  current,
  error,
}) {
  let context = React.useContext(MainContext);
  const { dropdown } = context;
  const [loading, setLoading] = React.useState("");

  const handleOther = async (type) => {
    try {
      switch (type) {
        case "q":
          setLoading("q");
          let res = await createCourse({
            course_name: data.other_qualification.name,
            course_approval: "",
          });
          if (res.data.data) {
            let tempArray = [...data.others, "q"];
            handleChanges(
              {
                ...data,
                others: [...new Set(tempArray)],
                other_qualification: {
                  ...data.other_qualification,
                  _id: res.data.data?._id,
                },
              },
              num
            );
          }
          break;
        case "s":
          setLoading("s");
          let resOne = await createSpecialization({
            specialization_name: data.other_specialization.name,
            specialization_approval: "",
          });
          if (resOne.data.data) {
            let tempArray = [...data.others, "s"];
            handleChanges(
              {
                ...data,
                others: [...new Set(tempArray)],
                other_specialization: {
                  ...data.other_specialization,
                  _id: resOne.data.data?._id,
                },
              },
              num
            );
          }
          break;
        case "u":
          setLoading("u");
          let resTwo = await createUniversity({
            university_name: data.other_university.name,
            university_approval: "",
          });
          if (resTwo.data.data) {
            let tempArray = [...data.others, "u"];
            handleChanges(
              {
                ...data,
                others: [...new Set(tempArray)],
                other_university: {
                  ...data.other_university,
                  _id: resTwo.data.data?._id,
                },
              },
              num
            );
          }
          break;
        case "c":
          setLoading("c");
          let resThree = await createCollege({
            college_name: data.other_college.name,
            college_approval: "",
          });
          if (resThree.data.data) {
            let tempArray = [...data.others, "c"];
            handleChanges(
              {
                ...data,
                others: [...new Set(tempArray)],
                other_college: {
                  ...data.other_college,
                  _id: resThree.data.data?._id,
                },
              },
              num
            );
          }
          break;

        default:
          break;
      }
    } catch (error) {
      setLoading("");
    }

    setLoading("");
  };
  let timer;
  const handleTimer = (type) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      handleOther(type);
      clearTimeout(timer);
    }, 1200);
  };

  React.useEffect(() => {
    if (!data.other_qualification.name) return;
    handleTimer("q");
  }, [data.other_qualification.name]);

  React.useEffect(() => {
    if (!data.other_specialization.name) return;
    handleTimer("s");
  }, [data.other_specialization.name]);

  React.useEffect(() => {
    if (!data.other_university.name) return;
    handleTimer("u");
  }, [data.other_university.name]);

  React.useEffect(() => {
    if (!data.other_college.name) return;
    handleTimer("c");
  }, [data.other_college.name]);

  return (
    <div className="qualification-form">
      {num ? (
        <div className="q-form-header">
          <p>Add Qualification ({num + 1})</p>
          <button onClick={() => handleDelete(num)}>Delete</button>
        </div>
      ) : (
        ""
      )}
      <CustomDropdown
        error={current && error && !data.qualification}
        sendClicked={(obj) =>
          handleChanges({ ...data, qualification: obj._id }, num)
        }
        list={dropdown?.courses || []}
        title="Qualification*"
        message="Select Qualification"
        selected={data.qualification}
      />
      {data.qualification === "other" && (
        <div
          className={`other-input ${
            current && error && !data.other_qualification._id
              ? "error-input"
              : ""
          }`}
        >
          <span>Specify Qualification*</span>
          <div className="other-wrapper">
            <input
              onChange={(e) => {
                clearTimeout(timer);
                handleChanges(
                  {
                    ...data,
                    other_qualification: { _id: "", name: e.target.value },
                  },
                  num
                );
              }}
              value={data.other_qualification.name}
              autoFocus
              placeholder=""
            />
            <div>
              <button>
                Requires admin approval{" "}
                <img src="https://img.icons8.com/material-sharp/50/000000/give-way.png" />
              </button>
              {loading === "q" ? (
                <img src="https://img.icons8.com/material-outlined/24/000000/dots-loading--v4.png" />
              ) : (
                <img src="https://img.icons8.com/ios/50/ff0000/info--v1.png" />
              )}
            </div>
          </div>
        </div>
      )}
      <CustomDropdown
        error={current && error && !data.specialization}
        sendClicked={(obj) =>
          handleChanges({ ...data, specialization: obj._id }, num)
        }
        list={dropdown?.specializations || []}
        title="Specialization*"
        message="Select Specialization"
        selected={data.specialization}
      />
      {data.specialization === "other" && (
        <div
          className={`other-input ${
            current && error && !data.other_specialization._id
              ? "error-input"
              : ""
          }`}
        >
          <span>Specify Specialization*</span>
          <div className="other-wrapper">
            <input
              onChange={(e) => {
                clearTimeout(timer);
                handleChanges(
                  {
                    ...data,
                    other_specialization: { _id: "", name: e.target.value },
                  },
                  num
                );
              }}
              value={data.other_specialization.name}
              autoFocus
              placeholder=""
            />
            <div>
              <button>
                Requires admin approval{" "}
                <img src="https://img.icons8.com/material-sharp/50/000000/give-way.png" />
              </button>
              {loading === "s" ? (
                <img src="https://img.icons8.com/material-outlined/24/000000/dots-loading--v4.png" />
              ) : (
                <img src="https://img.icons8.com/ios/50/ff0000/info--v1.png" />
              )}
            </div>
          </div>
        </div>
      )}
      <CustomDropdown
        error={current && error && !data.university}
        sendClicked={(obj) =>
          handleChanges({ ...data, university: obj._id }, num)
        }
        list={dropdown?.universities || []}
        title="University Name*"
        message="Select university"
        selected={data.university}
      />
      {data.university === "other" && (
        <div
          className={`other-input ${
            current && error && !data.other_university._id ? "error-input" : ""
          }`}
        >
          <span>Specify University*</span>
          <div className="other-wrapper">
            <input
              onChange={(e) => {
                clearTimeout(timer);
                handleChanges(
                  {
                    ...data,
                    other_university: { _id: "", name: e.target.value },
                  },
                  num
                );
              }}
              value={data.other_university.name}
              autoFocus
              placeholder=""
            />
            <div>
              <button>
                Requires admin approval{" "}
                <img src="https://img.icons8.com/material-sharp/50/000000/give-way.png" />
              </button>
              {loading === "u" ? (
                <img src="https://img.icons8.com/material-outlined/24/000000/dots-loading--v4.png" />
              ) : (
                <img src="https://img.icons8.com/ios/50/ff0000/info--v1.png" />
              )}
            </div>
          </div>
        </div>
      )}
      <CustomDropdown
        error={current && error && !data.college}
        sendClicked={(obj) => handleChanges({ ...data, college: obj._id }, num)}
        list={dropdown?.colleges || []}
        title="College Name*"
        message="Select college"
        selected={data.college}
      />
      {data.college === "other" && (
        <div
          className={`other-input ${
            current && error && !data.other_college._id ? "error-input" : ""
          }`}
        >
          <span>Specify College*</span>
          <div className="other-wrapper">
            <input
              onChange={(e) => {
                clearTimeout(timer);
                handleChanges(
                  {
                    ...data,
                    other_college: { _id: "", name: e.target.value },
                  },
                  num
                );
              }}
              value={data.other_college.name}
              autoFocus
              placeholder=""
            />
            <div>
              <button>
                Requires admin approval{" "}
                <img src="https://img.icons8.com/material-sharp/50/000000/give-way.png" />
              </button>
              {loading === "c" ? (
                <img src="https://img.icons8.com/material-outlined/24/000000/dots-loading--v4.png" />
              ) : (
                <img src="https://img.icons8.com/ios/50/ff0000/info--v1.png" />
              )}
            </div>
          </div>
        </div>
      )}

      <CustomDropdown
        error={current && error && !data.passing_year}
        sendClicked={(obj) =>
          handleChanges({ ...data, passing_year: obj.id }, num)
        }
        list={dropdown?.years || []}
        title="Passing Year*"
        message="Select Passing Year"
        selected={data.passing_year}
      />
      <CustomCheckBox
        error={current && error && !data.course_type}
        handleChange={(obj) =>
          handleChanges({ ...data, course_type: obj.id }, num)
        }
        title="Course Type*"
        list={courseTypeList}
        selected={data.course_type}
      />
    </div>
  );
}

const qualifications = [
  { keyId: nextId(), name: "Bachelor of Science", id: "Bsc" },
  { keyId: nextId(), name: "Bachelor of Engineering", id: "be" },
  { keyId: nextId(), name: "Bachelor of Arts", id: "ba" },
  { keyId: nextId(), name: "Bachelor of Commerce", id: "ba" },
];
const courseTypeList = [
  { _id: nextId(), name: "Full Time", id: "full_time" },
  { _id: nextId(), name: "Part Time", id: "part_time" },
  { _id: nextId(), name: "Correspondence", id: "correspondence" },
];
